import { Component, Input, Optional, Self } from '@angular/core';
import {NgControl } from '@angular/forms';
import { DateSelectBase } from '../date-select.base';

/**
 * Component for selecting a date input
 * 
 * @example <fgbcl-date-select formControlName="anyControlName"></fgbcl-date-select>
 */
@Component({
  selector: 'fgbcl-date-select',
  templateUrl: './date-select.component.html',
  styleUrls: ['./date-select.component.scss']
})
export class DateSelectComponent extends DateSelectBase{
  @Input() label: string;

  constructor(@Optional() @Self() protected ngControl: NgControl) { 
    super(ngControl);
  }

}
